export default function extractNumberSuffix(mailLines = []) {
  if (!Array.isArray(mailLines) || !mailLines.length) {
    return null;
  }
  const streetAddress = mailLines[0].trim();
  if (streetAddress === mailLines[0]) {
    // If the string has no trailing whitespace (number suffix was added), split and return the last part
    return streetAddress.split(' ').pop();
  }
  // If the string has a trailing whitespace (no number suffix added), return null
  return null;
}
